import { Circle, Text } from '@chakra-ui/react';

import { CheckOutline } from '@aslanpay/portal-common-lib';

import { StepCircleProps } from './types';

function StepCircle({ value, isActive, isCompleted }: StepCircleProps) {
  let bgColor;

  if (isActive) {
    bgColor = 'brand.purple';
  } else if (isCompleted) {
    bgColor = 'brand.purpleAlpha30';
  } else {
    bgColor = 'transparent';
  }

  return (
    <Circle
      size="30px"
      bgColor={bgColor}
      border={isActive || isCompleted ? 'unset' : '2px solid'}
      borderColor="brand.lightGray1"
    >
      {isCompleted ? (
        <CheckOutline color="brand.purple" boxSize="20px" />
      ) : (
        <Text color={isActive ? 'brand.white' : 'brand.darkGray'} textStyle="smallSemiBold">
          {value}
        </Text>
      )}
    </Circle>
  );
}

export default StepCircle;
